










































import Vue from 'vue';
import { MASS } from '@/mass/models/Mass';
import massClient from '../../apis';

const qrcodeUrl: string | undefined = undefined;
const createAuthResult: any | null = null;
const monitorTimer: any | null = null;
const bindHelperAuth: any | null = null;
const refreshAuthResult: any | null = null;

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MASS,
      showAddAdminBox: false,
      qrcodeUrl,
      createAuthResult,
      monitorTimer,
      bindingNeedConfirm: false,
      bindHelperAuth,
      refreshAuthResult,
      defaultAvatar: '',
      defaultNickname: '',
    };
  },
  methods: {
    confirmAuth() {
      massClient.confirmAuth({
        openid: this.createAuthResult.openid,
        authId: this.createAuthResult.helperAuthId}).success((r) => {
        if (r) {
          this.$emit('success');
          this.$Message.success('添加管理员成功');
        } else {
          this.$Message.error('添加失败，请刷新页面重试');
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    confirmReplaceAuth() {
      massClient.confirmReplaceAuth({
        oldWeixinId: this.refreshAuthResult.weixinId,
        openid: this.refreshAuthResult.openid, 
        authId: this.createAuthResult.helperAuthId}).success((r) => {
        if (r) {
          this.$emit('success');
          this.$Message.success('添加管理员成功');
        } else {
          this.$Message.error('添加失败，请刷新页面重试');
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    createAuth() {
      massClient.createAuth({}).success((r) => {
        this.createAuthResult = r;
        if (this.createAuthResult) {
          this.qrcodeUrl = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.createAuthResult.ticket;
        }
        if (this.createAuthResult.helperAuthId) {
          this.monitorTimer = setInterval(() => this.monitorAuth(), 3000);
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    monitorAuth() {
      massClient.monitorAuth({authId: this.createAuthResult.helperAuthId}).success((r) => {
        if (r.helperAuth) {
          this.bindingNeedConfirm = true;
          this.bindHelperAuth = r.helperAuth;
          this.refreshAuth();
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    refreshAuth() {
      clearInterval(this.monitorTimer);
      massClient.refreshAuth({openid: this.bindHelperAuth.openid}).success((r) => {
        this.refreshAuthResult = r;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    getImgUrl(customer: any) {
      if (customer) {
        return customer.wxProps.headimgurl.replace('http://', 'https://');
      } else {
        return this.defaultAvatar;
      }
    },
    getNickname(customer: any) {
      if (customer) {
        return customer.wxProps.nickname;
      } else {
        return this.defaultNickname;
      }
    },
    init() {
      this.qrcodeUrl = undefined;
      this.createAuthResult = null;
      this.monitorTimer = null;
      this.bindingNeedConfirm = false;
      this.bindHelperAuth = null;
      this.refreshAuthResult = null;
    },
    close() {
      clearInterval(this.monitorTimer);
      this.$emit('close');
    },
  },
  mounted() {
    this.showAddAdminBox = this.show;
  },
  watch: {
    show() {
      this.showAddAdminBox = this.show;
      if (this.show) {
        this.init();
        this.createAuth();
      }
    },
  },
});
